import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import qs from "qs";
import AlertConfirmPopup from "components/common/AlertConfirmPopup";
import { useCallback } from "react";

const RedirectComponent = () => {
    const history = useHistory();
    const location = useLocation();

    const query = qs.parse(location.search, {
        ignoreQueryPrefix: true,
    });

    const checkedValidation = useCallback(() => {
        const { TEST_SEQ, TSPAR_SEQ, MMBR_SEQ } = query;
        let checkedText = null;

        // console.log("TEST_SEQ, TSPAR_SEQ, queryUserId, queryMmbrSeq : ", TEST_SEQ, TSPAR_SEQ, USER_ID, MMBR_SEQ);

        if (!MMBR_SEQ) {
            checkedText = "MMBR_SEQ 값이 일치하지 않습니다.";
        } else if (!TEST_SEQ) {
            checkedText = "TEST_SEQ 값이 일치하지 않습니다.";
        } else if (!TSPAR_SEQ) {
            checkedText = "TSPAR_SEQ 값이 일치하지 않습니다.";
        }

        return checkedText;
    }, [query]);

    const handledChangeRoute = useCallback(() => {
        if (query) {
            const { TEST_SEQ, TSPAR_SEQ, MMBR_SEQ, TARGET_USER = "LMS" } = query;
            const checkedText = checkedValidation();

            if (checkedText) {
                AlertConfirmPopup({
                    type: "ALERT",
                    msg: checkedText,
                }).then((value) => {
                    if (value) history.push("/");
                });
                return null;
            } else {
                const PLAYER_TYPE = "playerMainResultViewer";
                const playerInfo = {
                    STD_TY_DVSN_CD: "RSBP_ALL", // 시험유형구분
                    MMBR_SEQ,
                    TEST_SEQ,
                    TSPAR_SEQ,
                    PLAYER_TYPE: "APPLY",
                    QST_TY: "QST_B", // 일괄채점
                    CONER_TY: "QST_B",
                    TARGET_USER,
                };

                const url = PLAYER_TYPE + "?" + qs.stringify(playerInfo);
                history.push(url);
            }
        }
    }, [history, query, checkedValidation]);

    React.useEffect(() => {
        handledChangeRoute();
    }, [handledChangeRoute]);

    React.useEffect(() => {
        return () => {};
    }, []);

    return null;
};

export default RedirectComponent;
